import { Money } from "shared-ts/classes/money"

interface ClickableBalanceProps {
  balance: Money
  onClick: () => void
}
export function ClickableBalance({ balance, onClick }: ClickableBalanceProps) {
  return (
    <>
      <span className="cursor-pointer hover:underline" onClick={onClick}>
        {balance.format()}
      </span>
    </>
  )
}
